import React, { useState } from 'react';
import './referral-link.css';
import { CheckIcon } from 'nexticons/outline';
import { ReactComponent as ReferralIcon } from '../../assets/images/referral-icon.svg';
import { ReactComponent as CopyIcon } from '../../assets/images/copy-icon.svg';
import { isLightColor } from './utils';

const ReferralLink = ({ 
  userLoyaltyDetails,
  themeColors,
  pointsTerminology = 'points',
  referralRule
}) => {
  const [copied, setCopied] = useState(false);
  // Generate referral URL
  const generateReferralUrl = () => {
    const referralId = userLoyaltyDetails?.id || userLoyaltyDetails?.userId;
    
    return `${window.location.origin}/loyalty?refId=${referralId}`;
  };

  const referralUrl = generateReferralUrl();
  const isLightBackground = isLightColor(themeColors.backgroundColor);
  const normalizedBackgroundColor = themeColors.backgroundColor.toLowerCase();
  const normalizedMainTextColor = themeColors.mainTextColor.toLowerCase();
  const fallbackContentColor = isLightBackground ? '#111111' : '#ffffff';
  const readableContentColor =
    normalizedBackgroundColor === normalizedMainTextColor
      ? fallbackContentColor
      : themeColors.mainTextColor;
  const iconWrapperBackgroundColor = themeColors.backgroundColor;
  const normalizedIconWrapperBackgroundColor =
    iconWrapperBackgroundColor.toLowerCase();
  const referralIconColor =
    readableContentColor.toLowerCase() === normalizedIconWrapperBackgroundColor
      ? isLightColor(iconWrapperBackgroundColor)
        ? '#111111'
        : '#ffffff'
      : readableContentColor;
  const referralIconWrapperStyle = {
    backgroundColor: iconWrapperBackgroundColor,
    border: isLightBackground
      ? '1px solid rgba(0, 0, 0, 0.2)'
      : '1px solid rgba(255, 255, 255, 0.22)',
  };
  const copyButtonStyle = {
    backgroundColor: copied ? '#10B981' : themeColors.backgroundColor,
    color: copied ? '#ffffff' : readableContentColor,
    transition: 'all 0.2s ease',
    ...(isLightBackground &&
      !copied && {
        border: '1px solid rgba(0, 0, 0, 0.2)',
      }),
  };

  const handleCopyToClipboard = async () => {
    if (!referralUrl) return;

    try {
      await navigator.clipboard.writeText(referralUrl);
      setCopied(true);
      
      // Reset copied state after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = referralUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  // Always render for now since we have fallback values
  if (!userLoyaltyDetails) {
    return null;
  }

  // Get points from referral rule
  const referralPoints = referralRule?.points || 0;
  
  return (
    <div className="referral-link-container">
      <div className="referral-link-header">
        <div className="referral-icon-wrapper" style={referralIconWrapperStyle}>
          <ReferralIcon 
            width="24" 
            height="24" 
            style={{ 
              color: referralIconColor
            }}
          />
        </div>
        <div className="referral-text">
          <h4 className="referral-title">Share & Earn</h4>
          <p className="referral-description">
            Invite friends and earn {referralPoints} {pointsTerminology} for each referral
          </p>
        </div>
      </div>

      <div className="referral-link-wrapper">
        <div className="referral-url-container">
          <input
            type="text"
            value={referralUrl}
            readOnly
            className="referral-url-input"
          />
          <button
            onClick={handleCopyToClipboard}
            className="copy-button"
            data-tooltip={copied ? "Copied!" : "Copy"}
            style={copyButtonStyle}
          >
            {copied ? (
              <>
                <CheckIcon />
              </>
            ) : (
              <>
                <CopyIcon 
                  width="16" 
                  height="16" 
                  style={{ 
                    color: readableContentColor
                  }}
                />
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReferralLink; 
